import Skeleton from "@/components/atoms/Skeleton";
import dynamic from "next/dynamic";

const ClientComponentWithFetcherNoSSR = dynamic(
  () => import("./ClientComponentWithFetcher"),
  {
    loading: () => <Skeleton height="200px" />,
  }
);

export default ClientComponentWithFetcherNoSSR;
